<section class="slider slider-cards" *ngIf="items.length" [class]="background">
  <header class="slider-header">
    <ng-content select=".slider-header__title"></ng-content>
  </header>

  <app-spinner *ngIf="loading"></app-spinner>

  <div class="slider-content" *ngIf="!loading">
    <swiper
      class="slider-list"
      #swiper
      [config]="config"
      [style.visibility]="loaded ? 'visible' : 'hidden'"
      (init)="loaded = true"
    >
      <app-card-article
        *ngFor="let item of items"
        class="swiper-slide"
        [item]="item"
        [lazySwiper]="true"
      ></app-card-article>
    </swiper>

    <div class="slider-cards-nav">
      <button
        (click)="navigate('prev')"
        class="btn slider-cards-prev slider-articles-prev"
        type="button"
      >
        <i class="icon-pointer-left"></i>
      </button>

      <button
        (click)="navigate('next')"
        class="btn slider-cards-next slider-articles-next"
        type="button"
      >
        <i class="icon-pointer-right"></i>
      </button>
    </div>
  </div>
</section>
